import { createInstance } from 'src/utils/fetch'
import {
  ICustomerContractDatesResponsePayload,
  TDownloadPayload,
  TRenewPayload,
  TSharedCustomerResponsePaylad,
  IIgnoreCasePayload,
  IAuditLogResponse
} from 'src/typings/types'

const fetch = createInstance({})

const billingApiUrl =
  process.env.REACT_APP_ENV === 'PROD'
    ? 'https://billing.knowyourcustomer.com/'
    : 'https://billing-devstage.knowyourcustomer.com/'

const AppAPI = {
  async getSharedCustomers(): Promise<TSharedCustomerResponsePaylad> {
    const { data } = await fetch.get(`${billingApiUrl}customers/with-missing`)
    return data.customers
  },
  async getCustomerContractDates(customerId: number): Promise<ICustomerContractDatesResponsePayload[]> {
    const { data } = await fetch.get(`${billingApiUrl}customers/${customerId}/contract-dates`)
    return data
  },
  async downloadReport(payload: TDownloadPayload): Promise<any> {
    return await fetch.post(`${billingApiUrl}Billing/generate`, payload)
  },
  async downloadRefinitivReport(payload: TDownloadPayload): Promise<any> {
    return await fetch.post(`${billingApiUrl}Billing/refinitiv`, payload)
  },
  async downloadSearchReport(payload: TDownloadPayload): Promise<any> {
    return await fetch.post(`${billingApiUrl}Billing/search-report`, payload)
  },
  async renew(payload: TRenewPayload): Promise<any> {
    return await fetch.post(`${billingApiUrl}Customers/renew`, payload)
  },
  async ignoreCases(payload: IIgnoreCasePayload): Promise<any> {
    return await fetch.post(`${billingApiUrl}cases/ignore`, payload)
  },
  async getEnviroments(sharedCustomerId: number): Promise<any> {
    return await fetch.get(`${billingApiUrl}Customers/${sharedCustomerId}/environments`)
  },
  async getAuditLog(sharedCustomerId: number, page = 1, size = 10, order: 1 | 2 = 1): Promise<IAuditLogResponse> {
    const { data } = await fetch.get(`${billingApiUrl}Customers/${sharedCustomerId}/audit`, {
      params: {
        Page: page,
        Size: Math.min(size, 100), // no more than 100 allowed
        Order: order
      }
    })
    return data
  }
}

export default AppAPI
